export function alumConfigOptions(width: number, isWindow: boolean) {
  let options: string[] = [];

  if (width > 392.4375 || width < 38.75) return [];

  if (width <= 101.75) {
    options.push("2L OR 2R");
  }

  if (width >= 60.125 && width <= 150.125) {
    options.push("3L OR 3R");
  }

  if (width >= 62.0625 && width <= 152.0625) {
    options.push("2L1R OR 1L2R");
  }

  if (width >= 78.75 && width <= 198.75) {
    options.push("4L OR 4R");
  }

  if (width >= 80.875 && width <= 200.875) {
    options.push("2L2R");
  }

  if (width >= 80.5625 && width <= 200.5625) {
    options.push("3L1R OR 1L3R");
  }

  if (width >= 97.0625 && width <= 247.0625) {
    options.push("5L OR 5R");
  }

  if (width >= 99 && width <= 249) {
    options.push("4L1R OR 1L4R", "3L2R OR 2L3R");
  }

  if (width >= 111) {
    if (width>= 115.25 && width <= 276) {
      options.push("6L OR 6R");
    }

    if (width >= 117.0625 && width <= 297.6875) {
      options.push("3L3R", "5L1R OR 1L5R");
    }

    if (width >= 117.375 && width <= 297.6875) {
      options.push("4L2R OR 2L4R");
    }
  }

  if (isWindow) {
    return options;
  }

  if (width >= 206.5625 && width <= 276) {
    options.push("7L OR 7R");
  }

  if (width >= 206.5625 && width <= 323.5) {
    options.push("6L1R OR 1L6R");
  }

  if (width >= 225.25 && width <= 344) {
    options.push("4L3R OR 3L4R", "5L2R OR 2L5R");
  }

  if (width >= 242.5625) {
    if (width <= 316.8125) {
      options.push("7L1R OR 1L7R");
    }

    if (width <= 368.875) {
      options.push("6L2R OR 2L6R");
    }

    options.push("5L3R OR 3L5R", "4L4R");
  }

  return options;
}

export function configOptions(width: number, isWindow: boolean) {
  let options: string[] = [];

  if (width > 339.25 || width < 38.75) return [];

  if (width <= 98.375) {
    options.push("2L OR 2R");
  }

  if (width <= 146.5 && width >= 56.5625) {
    options.push("3L OR 3R", "2L1R OR 1L2R");
  }

  if (width <= 194.6875 && width >= 74.75) {
    options.push("4L OR 4R", "2L2R", "3L1R OR 1L3R");
  }

  if (width >= 92.8125) {
    if (width <= 242.8125) {
      options.push("5L OR 5R", "4L1R OR 1L4R", "3L2R OR 2L3R");
    }
  }

  if (width >= 111) {
    if ((isWindow && width <= 255) || (!isWindow && width <= 291)) {
      options.push("6L OR 6R", "3L3R", "5L1R OR 1L5R", "4L2R OR 2L4R");
    }
  }

  if (isWindow) {
    return options;
  }
  //can't do 7 panel because tracks are 24 ft long

  if (width >= 218.5625) {
    if (width <= 290.125) {
      options.push("7L OR 7R", "6L1R OR 1L6R");
    }

    options.push("4L3R OR 3L4R", "5L2R OR 2L5R");
  }

  if (width >= 242.5625) {
    options.push("7L1R OR 1L7R", "6L2R OR 2L6R", "5L3R OR 3L5R", "4L4R");
  }

  return options;
}

export function comboConfigOptions(arg: {
  width: number;
  isWindow: boolean;
  side: string;
}) {
  let options: string[] = [];

  const { width, isWindow, side } = arg;

  if (width > 290.125 || width < 38.75) return [];

  if (width <= 98.375) {
    options.push("2L", "2R");
  }

  if (width <= 146.5 && width >= 56.5625) {
    options.push("3L", "3R");
  }

  if (width <= 194.6875 && width >= 74.75) {
    options.push("4L", "4R");
  }

  if (width >= 92.8125 && width <= 242.8125) {
    options.push("5L", "5R");
  }

  if (width >= 111) {
    if ((isWindow && width <= 255) || (!isWindow && width <= 291)) {
      options.push("6L", "6R");
    }
  }

  if (isWindow) {
    return options.filter((itm) => itm.includes(side));
  }
  //can't do 7 panel because tracks are 24 ft long
  if (width >= 218.5625) {
    options.push("7L", "7R");
  }

  return options.filter((itm) => itm.includes(side));
}

export function cornerConfigOptions(width: number, side: "L" | "R") {
  if (width > 291 || width < 30) return [];

  function formatConfig(...panels) {
    let options: string[] = [];
    for (let panel of panels) {
      options.push(`${panel}${side}`);
    }
    return options;
  }

  if (width <= 50.25) {
    return formatConfig(1, 2);
  }

  if (width <= 56.5) {
    return formatConfig(2);
  }

  if (width <= 74.6875) {
    return formatConfig(2, 3);
  }

  if (width <= 92.75) {
    return formatConfig(2, 3, 4);
  }

  if (width <= 98.375) {
    return formatConfig(2, 3, 4, 5);
  }

  if (width <= 110.9375) {
    return formatConfig(3, 4, 5);
  }

  if (width <= 146.5) {
    return formatConfig(3, 4, 5, 6);
  }

  if (width <= 194.6875) {
    return formatConfig(4, 5, 6);
  }

  if (width <= 218.5) {
    return formatConfig(5, 6);
  }

  if (width <= 242.5) {
    return formatConfig(5, 6, 7);
  }

  if (width <= 242.8125) {
    return formatConfig(5, 6, 7, 8);
  }

  if (width <= 290.125) {
    return formatConfig(6, 7, 8);
  }

  return formatConfig(6, 8);
}

export function sliderPocketConfigOptions(width: number) {
  if (width < 24 || width > 452) return [];

  if (width <= 48.5) {
    return ["PX OR XP"];
  }

  if (width <= 72.5) {
    return ["PX OR XP", "PXX OR XXP", "PX-XP"];
  }

  if (width <= 96.375) {
    return ["PX OR XP", "PXX OR XXP", "PXXX OR XXXP", "PX-XP"];
  }

  if (width <= 96.5) {
    return ["PXX OR XXP", "PXXX OR XXXP", "PX-XP"];
  }

  if (width <= 144.5) {
    return ["PXX OR XXP", "PXXX OR XXXP", "PXXXX OR XXXXP", "PX-XP", "PXX-XXP"];
  }

  if (width <= 188.9375) {
    return [
      "PXX OR XXP",
      "PXXX OR XXXP",
      "PXXXX OR XXXXP",
      "PX-XP",
      "PXX-XXP",
      "PXXX-XXXP",
    ];
  }

  if (width <= 190.8125) {
    return ["PXXX OR XXXP", "PXXXX OR XXXXP", "PX-XP", "PXX-XXP", "PXXX-XXXP"];
  }

  if (width <= 192.5) {
    return ["PXXX OR XXXP", "PXXXX OR XXXXP", "PXX-XXP", "PXXX-XXXP"];
  }

  if (width <= 212.5) {
    return [
      "PXXX OR XXXP",
      "PXXXX-XXXXP",
      "PXX-XXP",
      "PXXX-XXXP",
      "PXXXX OR XXXXP",
    ];
  }

  if (width <= 288) {
    return ["PXXXX OR XXXXP", "PXX-XXP", "PXXX-XXXP", "PXXXX-XXXXP"];
  }

  if (width <= 375.9375) {
    return ["PXX-XXP", "PXXX-XXXP", "PXXXX-XXXXP"];
  }

  if (width <= 425) {
    return ["PXXX-XXXP", "PXXXX-XXXXP"];
  }

  return ["PXXXX-XXXXP"];
}

export function sliderNonPocketConfigOptions(width: number) {
  if (width < 48 || width > 576) return [];

  if (width <= 72.5) {
    return ["OX OR XO", "XX"];
  }

  if (width <= 96.5) {
    return ["OX OR XO", "OXX OR XXO", "XX", "XXX"];
  }

  if (width <= 120) {
    return [
      "OX OR XO",
      "OXX OR XXO",
      "OXXX OR XXXO",
      "OX-XO",
      "XX",
      "XXX",
      "XXXX",
    ];
  }

  if (width <= 144.5) {
    return [
      "OX OR XO",
      "OXX OR XXO",
      "OXXX OR XXXO",
      "OXXXX OR XXXXO",
      "OX-XO",
      "XX",
      "XXX",
      "XXXX",
    ];
  }

  if (width <= 190.6875) {
    return [
      "OX OR XO",
      "OXX OR XXO",
      "OXXX OR XXXO",
      "OXXXX OR XXXXO",
      "OX-XO",
      "OXX-XXO",
      "XX",
      "XXX",
      "XXXX",
    ];
  }

  if (width <= 191) {
    return [
      "OX OR XO",
      "OXX OR XXO",
      "OXXX OR XXXO",
      "OXXXX OR XXXXO",
      "OX-XO",
      "OXX-XXO",
      "XXX",
      "XXXX",
    ];
  }

  if (width <= 192.5) {
    return [
      "OXX OR XXO",
      "OXXX OR XXXO",
      "OXXXX OR XXXXO",
      "OX-XO",
      "OXX-XXO",
      "XXX",
      "XXXX",
    ];
  }

  if (width <= 240) {
    return [
      "OXX OR XXO",
      "OXXX OR XXXO",
      "OXXXX OR XXXXO",
      "OX-XO",
      "OXX-XXO",
      "OXXX-XXXO",
      "XXX",
      "XXXX",
    ];
  }

  if (width <= 283) {
    return [
      "OXX OR XXO",
      "OXXX OR XXXO",
      "OXXXX OR XXXXO",
      "OX-XO",
      "OXX-XXO",
      "OXXX-XXXO",
      "OXXXX-XXXXO",
      "XXX",
      "XXXX",
    ];
  }

  if (width <= 283.25) {
    return [
      "OXXX OR XXXO",
      "OXXXX OR XXXXO",
      "OX-XO",
      "OXX-XXO",
      "OXXX-XXXO",
      "OXXXX-XXXXO",
      "XXX",
      "XXXX",
    ];
  }

  if (width <= 288) {
    return [
      "OXXX OR XXXO",
      "OXXXX OR XXXXO",
      "OX-XO",
      "OXX-XXO",
      "OXXX-XXXO",
      "OXXXX-XXXXO",
      "XXXX",
    ];
  }

  if (width <= 380.0625) {
    return ["OX-XO", "OXX-XXO", "OXXX-XXXO", "OXXXX-XXXXO"];
  }

  if (width <= 565.1875) {
    return ["OXX-XXO", "OXXX-XXXO", "OXXXX-XXXXO"];
  }

  return ["OXXX-XXXO", "OXXXX-XXXXO"];
}

export interface InitialExpandItm {
  name: string;
  expanded: boolean;
  require?: boolean;
}

export const initialExpand = [
  { name: "material", expanded: false },
  { name: "wood", expanded: false },
  { name: "unitSize", expanded: false },
  { name: "height", expanded: false },
  { name: "configuration", expanded: false },
  { name: "quantity", expanded: false, require: true },
  { name: "exteriorClad", expanded: false, require: true }, //6
  { name: "swingDirection", expanded: false },
  { name: "stilesRails", expanded: false, require: true },
  { name: "glass", expanded: false, require: true },
  { name: "paintPrime", expanded: false, require: false },
  { name: "stain", expanded: false, require: false },
  { name: "headTrack", expanded: false, require: true },
  { name: "sill", expanded: false, require: true },
  { name: "strip", expanded: false, require: true },
  { name: "spacer", expanded: false, require: true },
  { name: "handle", expanded: false, require: true },
  { name: "handleHeight", expanded: false, require: true },
  { name: "shootBolt", expanded: false, require: true },
  { name: "stickStops", expanded: false, require: true },
  { name: "hinge", expanded: false, require: true },
  { name: "ebm", expanded: false },
  { name: "fin", expanded: false, require: false },
  { name: "lite", expanded: false, require: false },
  { name: "dl", expanded: false, require: false },
  { name: "screen", expanded: false, require: false },
  { name: "screenNotRequired", expanded: false, require: false },
  { name: "screenPocket", expanded: false },
  { name: "jamb", expanded: false, require: true }, //27
  { name: "sliderConfig", expanded: false, require: true },
  { name: "sliderWidth", expanded: false, require: true },
  { name: "automation", expanded: false, require: false },
  { name: "screenType", expanded: false, require: false },
  { name: "slidingScreen", expanded: false, require: false },
  { name: "kerf", expanded: false, require: false },
  { name: "corner", expanded: false, require: true },
  { name: "pivot", expanded: false, require: true },
  { name: "pivotHardware", expanded: false, require: true },
  { name: "pivotMagnet", expanded: false, require: false },
  { name: "dropseal", expanded: false, require: false },
  { name: "magnetCatch", expanded: false, require: false },
  { name: "squareHinges", expanded: false, require: false },
  { name: "aluminumColor", expanded: false, require: false },
  { name: "stilesRailsProfile", expanded: false, require: false },
  { name: "restrictor", expanded: false, require: false },
  { name: "doorShoeColor", expanded: false, require: false },
];
